import { render, staticRenderFns } from "./formPacientes.vue?vue&type=template&id=50af0f9a"
import script from "./formPacientes.vue?vue&type=script&lang=ts"
export * from "./formPacientes.vue?vue&type=script&lang=ts"
import style0 from "./formPacientes.vue?vue&type=style&index=0&id=50af0f9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports